import React, { useEffect, useState } from "react";
import "./Inner_Products.css";
import Product_card from "../../common-components/common-card/product-card/Product_card";
import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";
import { useNavigate, useParams } from "react-router-dom";
import { getProducts } from "../../../utils/apis/products/Product";
import { IDS } from "../../../utils/common";
import WhatsappChatbot from "../../common-components/chatbot/Chatbot";

const Inner_Products = ({ categoryId: propCategoryId }) => {
  const { categoryId, id } = useParams();

  const selectedCategoryId = propCategoryId || categoryId;

  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const getProductData = async () => {
      try {
        const res = await getProducts(selectedCategoryId);

        if (res?.success && Array.isArray(res?.data)) {
          const products = res.data;

          // Backend has already filtered products by category_id.
          let categoryProducts = products;

          // Keep existing behavior:
          // If this is a product description page,
          // don't show the current product in related products.
          if (id) {
            categoryProducts = products.filter(
              (item) => Number(item?.id) !== Number(id),
            );
          }

          // Category name comes directly from backend.
          const categoryName = products?.[0]?.Category?.name || "Products";

          setData([
            {
              category: categoryName,
              products: categoryProducts,
            },
          ]);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        setData([]);
      }
    };

    getProductData();
  }, [selectedCategoryId, id]);

  return (
    <section className="Inner_Products">
      <div className="container-fluid">
        {/* -------- CATEGORY TITLE ---- */}
        <Common_Title_2 titleText={data?.[0]?.category || "Products"} />

        {/* ----------- CATEGORY PRODUCTS --------- */}
        {data?.map((category) => (
          <div className="row" key={category?.category}>
            {category?.products?.length > 0 ? (
              category.products.map((product) => (
                <div
                  className="col-lg-3 col-md-6 col-sm-6 col-12 p-1 mb-2"
                  key={product?.id}
                  onClick={() =>
                    navigate(`/product-description/${product?.id}`)
                  }
                  style={{ cursor: "pointer" }}
                >
                  <Product_card
                    id={product?.id}
                    image={IDS?.IMG_URL + product?.image}
                    price={product?.price}
                    product_name={product?.name}
                    description={product?.description}
                  />
                </div>
              ))
            ) : (
              <div className="col-12 text-center py-4">
                <p>No products found in this category.</p>
              </div>
            )}
          </div>
        ))}

        {/* ----------- OTHER CATEGORIES ------ */}

        {/*
        {categories?.length > 0 && (
          <div className="other_cats_div">

            <Common_Title_2 titleText={"Our Other Products"} />

            <div className="all_cats_holder">
              <div className="row">

                {categories.map((item) => (
                  <div
                    className="col-lg-3 col-md-4 col-sm-6 col-6"
                    key={item?.id}
                  >
                    <div
                      className="cat_img_holder"
                      onClick={() => {
                        navigate(
                          `/products/${item?.name}`
                        );
                      }}
                    >
                      <img
                        src={
                          IDS?.IMG_URL +
                          item?.image
                        }
                        className="cat_img"
                        alt={item?.name}
                      />
                    </div>
                  </div>
                ))}

              </div>
            </div>

          </div>
        )}
        */}

        <WhatsappChatbot />
      </div>
    </section>
  );
};

export default Inner_Products;
